import * as React from 'react';
import { observer } from 'mobx-react';
import Loader from '../Loader';
import ReportsView from './ReportsView';
import ReportsStore from '../../ReportsStore';

interface Props {
  store: ReportsStore;
}

const ReportsState: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'ready':
      return <ReportsView reportsResource={store.state.reportsResource} />;
    case 'error':
      return <></>;
  }
};

export default observer(ReportsState);
